module.exports = __webpack_public_path__ + "media/images/avatar_male-c431320dc871f43b80828e17615b7963.png";